export default __webpack_public_path__ + "static/media/EUEnergyStats.6671a313.jpg";